module.exports = __webpack_public_path__ + "media/images/logo-insel-2-e8e40c8f8f310c7de0a8388562d69867.png";